"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRenderAttachment;

var _useWebChatAPIContext2 = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRenderAttachment() {
  var _useWebChatAPIContext = (0, _useWebChatAPIContext2.default)(),
      attachmentRenderer = _useWebChatAPIContext.attachmentRenderer;

  return attachmentRenderer;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VSZW5kZXJBdHRhY2htZW50IiwidXNlV2ViQ2hhdEFQSUNvbnRleHQiLCJhdHRhY2htZW50UmVuZGVyZXIiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VSZW5kZXJBdHRhY2htZW50LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlUmVuZGVyQXR0YWNobWVudCgpIHtcbiAgY29uc3QgeyBhdHRhY2htZW50UmVuZGVyZXIgfSA9IHVzZVdlYkNoYXRBUElDb250ZXh0KCk7XG5cbiAgcmV0dXJuIGF0dGFjaG1lbnRSZW5kZXJlcjtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBRWUsU0FBU0EsbUJBQVQsR0FBK0I7RUFDNUMsNEJBQStCLElBQUFDLDhCQUFBLEdBQS9CO0VBQUEsSUFBUUMsa0JBQVIseUJBQVFBLGtCQUFSOztFQUVBLE9BQU9BLGtCQUFQO0FBQ0QifQ==